<template>
<div class="col-12 text-left">
  <app-nav-bar></app-nav-bar>
  <div class="main-content">
    <h3 class="align-left">
      <small class="text-muted">NCR - Dashboard View</small>
    </h3>
    <div class="dropdown-divider"></div><br />
    <app-modal :elements="modalElements" v-on:confirm="del"></app-modal>
    <app-data-search v-on:searching="search"></app-data-search>
    <button type="button" class="btn btn-outline-info" @click="edit">Edit <i class="far fa-edit"></i></button>
    <button type="button" class="btn btn-outline-success" @click="previewcparncr">Print CPAR-NCR <i class="fas fa-print"></i></button>
    <!-- <button type="button" class="btn btn-outline-danger" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Delete <i class="far fa-trash-alt"></i></button> -->
    <!-- <button type="button" class="btn btn-outline-success" @click="preview">Preview <i class="fas fa-print"></i></button> -->
    <br /><br />
    <app-datatable :type="'view'" :elements="dtElements" :collections="ncr" v-on:selectedRow="selectRow"></app-datatable>
    <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
  </div>
</div>
</template>

<script>
import api from '../../services/api'
import { ncrUser } from '../../models/ncrUser'
import AppDatatable from '../../components/AppDatatable.vue'
import AppModal from '../../components/AppModal.vue'
import AppDataPagination from '../../components/AppDataPagination.vue'
import AppDataSearch from '../../components/AppDataSearch.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
      AppDatatable, AppModal, AppDataPagination, AppDataSearch, AppNavBar
    },
    data() {
      return {
        ncr: [ncrUser],
        dtElements: [
          {
            title: 'NCR No',
            column: 'ncrNo',
            type: 'text'
          },
          {
            title: 'NCR Date',
            column: 'ncrDate',
            type: 'date'
          },
          {
            title: 'Description',
            column: 'description',
            type: 'text'
          },
          {
            title: 'Status',
            column: 'status',
            type: 'text'
          },
        ],
        modalElements: {
          modalId: 'ncr-user',
          title: 'Confirm',
          content: 'Are you sure to delete this data?',
          type: 'text-confirm'
        },
        selectedId: '',
        searchKey: '',
        pagination: {
          pageSize: 10,
          currentPage: 1
        }
      }
  },
  async created() {
    this.init()
  },
  methods: {
    async init() {
      const ncrApi = api('ncr-dashboard/partial')
      const query = {
        params: {
          searchKey: this.searchKey,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }
      }
      this.ncr = await ncrApi.getWithQuery(query) 
    },
    edit() {
      if(this.selectedId !== '') {
        this.$router.push({
          name: 'ncrDashboardDetail',
          query: {
            id: this.selectedId
          }
        })
      }
    },
    previewcparncr() {
      if(this.selectedId !== '') {
        // this.$router.push({
        //   name: 'cpar-ncr',
        //   query: {
        //     id: this.selectedId
        //   }
        // })
        let newTab = this.$router.resolve({name: 'cpar-ncr', query: {id: this.selectedId}});
        window.open(newTab.href, '_blank');
      }
    },
    selectRow(id) {
      this.selectedId = id
    },
    changePage(payload) {
      this.pagination = payload
      this.init()
    },
    search(searchKey) {
      this.searchKey = searchKey
      this.init()
    }
  }
}
</script>